/**
 * The Crown Jewels tag (client notes 11/2): the assets the day-to-day operations cannot do without. An element carries it in
 * its `tags`; the console only reads it, so the tag can come from the backend or from the person who owns the asset.
 * Spaces, hyphens and case are not told apart ("Crown Jewel", "crown-jewels" and "crown_jewel" are one tag), because a
 * tag is typed by a person.
 */
export const CROWN_JEWEL_TAG = 'crown_jewel';

function normalizeTag(tag: unknown): string {
  return String(tag ?? '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');
}

/** Whether an element is tagged as a crown jewel. */
export function isCrownJewel(element: { tags?: unknown } | null | undefined): boolean {
  const tags = element?.tags;
  if (!Array.isArray(tags)) return false;
  return tags.some((tag) => {
    const word = normalizeTag(tag);
    return word === CROWN_JEWEL_TAG || word === `${CROWN_JEWEL_TAG}s`;
  });
}
